const ArtworkClass = `
  id
  name
`;

export default ArtworkClass;
